/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Toggle/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function Toggle({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/AutoApplyToggle/Toggle",
  onChange,
  isSubmitting
  
}) {
let paymentsPostPaymentAutoApplyToUnpaidReceivablesValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'auto_apply_to_unpaid_receivables',
})
let paymentsPostPaymentAutoApplyToUnpaidReceivablesChangeData = fromData.useDataChange({ viewPath,
context: 'payments_post_payment',
path: 'auto_apply_to_unpaid_receivables',
})
let paymentsPostPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_post_payment',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 marginTop={0}
 data="payments_post_payment.auto_apply_to_unpaid_receivables"
 value={paymentsPostPaymentAutoApplyToUnpaidReceivablesValueData}
 onChange={paymentsPostPaymentAutoApplyToUnpaidReceivablesChangeData}
 data="payments_post_payment"
 disabled={paymentsPostPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Auto-apply to unpaid receivables"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}